import type {EnvironmentSubmit} from '../../../hooks/use-environment-selection'
import type {EnvironmentOption} from './environment-option'
import type {PreparedPrompt} from '@github-ui/ahp-session-client/contracts'

interface DispatchEnvironmentSubmissionInput {
  selectedEnvironment: EnvironmentOption | null
  onEnvironmentSubmit?: EnvironmentSubmit
  prompt: PreparedPrompt
  repositoryNwo?: string
  baseRef?: string
}

export async function dispatchEnvironmentSubmission({
  selectedEnvironment,
  onEnvironmentSubmit,
  prompt,
  repositoryNwo,
  baseRef,
}: DispatchEnvironmentSubmissionInput): Promise<boolean> {
  const isRelayBacked = selectedEnvironment?.kind === 'ahp' || selectedEnvironment?.kind === 'sandbox'
  if (isRelayBacked && selectedEnvironment.environmentId && onEnvironmentSubmit) {
    await onEnvironmentSubmit({
      environmentId: selectedEnvironment.environmentId,
      prompt,
      ...(repositoryNwo ? {repositoryNwo} : {}),
      ...(baseRef ? {baseRef} : {}),
      ...(selectedEnvironment.kind === 'sandbox' ? {managedSandbox: true} : {}),
    })
    return true
  }
  return false
}
